/** Keep in sync with BetBond Game36 pending expiry and backend expire job. */

export const PENDING_ROUND_EXPIRE_MS = 90 * 1000;
export const PENDING_ROUND_WARN_SECONDS = 30;

export const getPendingRoundExpiresAt = (round) => {
  if (!round) return null;
  const base = round.updatedAt || round.createdAt;
  if (!base) return null;
  const t = new Date(base).getTime();
  if (!Number.isFinite(t)) return null;
  return t + PENDING_ROUND_EXPIRE_MS;
};

export const getPendingRoundSecondsLeft = (round, now = Date.now()) => {
  const expiresAt = getPendingRoundExpiresAt(round);
  if (expiresAt == null) return null;
  return Math.max(0, Math.ceil((expiresAt - now) / 1000));
};

export const isPendingRoundPlayable = (round, now = Date.now()) => {
  const secondsLeft = getPendingRoundSecondsLeft(round, now);
  return secondsLeft != null && secondsLeft > 0;
};

export const formatExpiryCountdown = (secondsLeft) => {
  const total = Math.max(0, Number(secondsLeft) || 0);
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};
